/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import { React } from 'react'
import AnimatedList from '../../../../components/Animation/AnimatedList'



const TableBodyDevice = ({ tableData,patientId,List,isLoading,itemsindexNum }) => {

    
    const user_id = localStorage.getItem('user_id');
    

    return (
        <>
            <AnimatedList
                id={tableData.device_id}

                child={
                    <>
                        <td data-testid="device_id" className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.device_id}</td>
                        <td data-testid="reading_type" className="px-[18px] py-2 text-sm text-start font-normal text-[#031624] break-words" >
                            <span>

                                {tableData?.reading_type && tableData?.reading_type.length > 0 ?
                                    <p className="text-base capitalize text-normal text-[#000B17] pt-2 break-words">
                                        {/* {tableData.reading_type.join(', ')} */}
                                        {[tableData?.reading_type] &&
                                                                typeof [tableData?.reading_type] === 'string'
                                            ? [tableData?.reading_type].replace(/[_-]/g, " ")
                                            : ([tableData?.reading_type ]|| '').toString().replace(/[_-]/g, " ")}
                                    </p>
                                    :
                                    <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                        -
                                    </p>
                                }
                            </span>
                        </td>
                        <td data-testid="manufacturer_name" className={`px-[18px] py-2 text-sm text-start font-normal text-[#031624] rounded-tr-[2px] rounded-br-[2px]`}>
                            {tableData?.manufacturer_name}
                        </td>
                    </>

                } />

        </>
    )
}

export default TableBodyDevice